import { render, staticRenderFns } from "./BusinessNameDetails.vue?vue&type=template&id=28ec7746&scoped=true&"
import script from "./BusinessNameDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec7746",
  null
  
)

export default component.exports